/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import type { IBrand, IErrorResponse } from '@/types';

import { useQuery } from '@tanstack/react-query';

import { urls } from '@/statics';

const useBrands = () => {
  return useQuery<IBrand[], IErrorResponse>({
    queryKey: [urls.brands],
    staleTime: Infinity,
    gcTime: Infinity,
  });
};

export default useBrands;
